export const configurationProductConstant = {

    selectedShow: 'SELECTED_SHOW',
    selectedHide: 'SELECTED_HIDE',
};